import { render, staticRenderFns } from "./unbindAtTheInformation.vue?vue&type=template&id=e55960f4&scoped=true&"
import script from "./unbindAtTheInformation.vue?vue&type=script&lang=js&"
export * from "./unbindAtTheInformation.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/tablecss.less?vue&type=style&index=0&id=e55960f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55960f4",
  null
  
)

export default component.exports